import { Flex, IconButton, Text } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { HiOutlineDotsVertical } from 'react-icons/hi';

import { AdminUserListViewQuery } from '@/@generated/codegen/API';
import ClientTag from '@/components/ClientTag/ClientTag';
import TeamTag from '@/components/TeamTag/TeamTag';
import dateInRangeFilterFn from '@/ui/TanstackTable/Filter/date/dateInRangeFilterFn';
import { parseDate } from '@/utils/helpers/parseDate';

export type AdminUserListItemType = AdminUserListViewQuery['listUsers']['edges'][number]['node'];

const columnHelper = createColumnHelper<AdminUserListItemType>();

export const getColumns = (
  t: TFunction<'translation', undefined, 'translation'>,
  setSelectedRow: (row: AdminUserListItemType) => void
) => {
  const columns = [
    columnHelper.accessor('email', {
      header: 'Email',
      enableSorting: true,
      cell: (props) => <Text>{props.getValue()}</Text>,
    }),
    columnHelper.accessor('client', {
      header: 'Client',
      enableSorting: false,
      cell: (props) => {
        const clientName = props.row.original.client?.name;
        if (!clientName) return null;
        return (
          <Flex flexWrap="wrap" gap="2px">
            <ClientTag client={clientName} />
          </Flex>
        );
      },
    }),
    columnHelper.accessor('team', {
      header: 'Team',
      enableSorting: false,
      cell: (props) => {
        const teamName = props.row.original.team?.name;
        if (!teamName) return null;
        return (
          <Flex flexWrap="wrap" gap="2px">
            <TeamTag team={teamName} />
          </Flex>
        );
      },
    }),
    // NOTE: deprecated feature

    // columnHelper.display({
    //   id: 'currentMeetingID',
    //   header: 'Running meeting',
    //   cell: (props) => {
    //     if (
    //       props.row.original.currentMeetingID &&
    //       props.row.original.currentMeetingID != NULL_ID_VALUE
    //     )
    //       return (
    //         <Tag bgColor="primary" color="white">
    //           {props.row.original.currentMeetingID}
    //         </Tag>
    //       );
    //     return <Text>no active meeting</Text>;
    //   },
    // }),

    // NOTE: deprecated feature

    // columnHelper.accessor('last_seen', {
    //   header: 'Last seen',
    //   filterFn: dateInRangeFilterFn,
    //   cell: (props) => <Text>{parseDate(props.getValue() || '')}</Text>,
    // }),
    columnHelper.accessor('id', {
      header: 'Id',
      enableSorting: false,
      cell: (props) => <Text>{props.row.original.id}</Text>,
    }),
    columnHelper.accessor('isGuest', {
      header: 'Temp',
      size: 20,
      cell: (props) => (
        <Text color={props.row.original.isGuest ? 'red' : 'black'}>
          {props.row.original.isGuest ? 'yes' : 'no'}
        </Text>
      ),
    }),
    columnHelper.accessor('createdAt', {
      header: 'Joined',
      filterFn: dateInRangeFilterFn,
      cell: (props) => <Text>{parseDate(props.getValue().toString() || '')}</Text>,
    }),
    columnHelper.display({
      id: 'actions',
      header: 'Actions',
      size: 85,
      cell: (props) => (
        <Flex alignItems="center" justifyContent="center">
          <IconButton
            size="xs"
            aria-label="manage"
            bg="transparent"
            _hover={{
              transform: 'scale(1.1)',
              transition: 'all 0.2s ease-out',
            }}
            onClick={() => setSelectedRow(props.row.original)}
            icon={<HiOutlineDotsVertical />}
          />
        </Flex>
      ),
    }),
  ];

  return columns;
};
